export default "/images/43afc259ade57f87d18519ac5329c8a5.avif";